import { useState } from "react";

/**
 * Open/closed state and the draft for the one row being edited inline.
 * `start` opens it with a fresh copy of `initial` (the saved value);
 * `cancel` closes it, and is also what a page calls after a successful save.
 */
export function useInlineEdit<TDraft>(initial: TDraft) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(initial);

  const start = () => {
    setDraft(initial);
    setEditing(true);
  };
  const cancel = () => setEditing(false);

  return { editing, draft, setDraft, start, cancel };
}
